import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { Helmet } from "react-helmet";

const DefaultSEO = ({ data, location }) => {
  const pageTitle = location.pathname.split("/")[1];
  const capitalizedPageTitle =
    pageTitle.charAt(0).toUpperCase() + pageTitle.slice(1);
  const finalPageTitle =
    capitalizedPageTitle === ""
      ? "Wolfe Hall"
      : `${capitalizedPageTitle} – Wolfe Hall`;

  return (
    <Helmet
      title={`${finalPageTitle}`}
      meta={[
        {
          name: "viewport",
          content: `width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no`,
        },
        {
          name: "description",
          content: `${data.prismicHomepage.data.seo_text}`,
        },
        {
          name: "keywords",
          content: `${data.prismicHomepage.data.seo_keywords}`,
        },
        {
          name: "og:title",
          content: `${finalPageTitle}`,
        },
        {
          name: "og:type",
          content: `website`,
        },
        {
          name: "og:image",
          content: `${data.prismicHomepage.data.seo_image.url}`,
        },
        {
          name: "og:image:secure_url",
          content: `${data.prismicHomepage.data.seo_image.url}`,
        },
        {
          name: "og:description",
          content: `${data.prismicHomepage.data.seo_text}`,
        },
        {
          name: "og:image:width",
          content: `1200`,
        },
        {
          name: "og:image:height",
          content: `630`,
        },
        {
          name: "og:locale",
          content: `en`,
        },
        {
          name: "twitter:title",
          content: `Wolfe Hall`,
        },
        {
          name: "twitter:description",
          content: `${data.prismicHomepage.data.seo_text}`,
        },
        {
          name: "twitter:card",
          content: `summary_large_image`,
        },
        {
          name: "twitter:image",
          content: `${data.prismicHomepage.data.seo_image.url}`,
        },
      ]}
      link={[
        {
          rel: "preload",
          href: "/fonts/Starling-Arrow.eot",
          as: "font",
          crossOrigin: "anonymous",
        },
        {
          rel: "preload",
          href: "/fonts/Starling-Arrow.ttf",
          as: "font",
          crossOrigin: "anonymous",
        },
        {
          rel: "preload",
          href: "/fonts/Starling-Arrow.woff",
          as: "font",
          crossOrigin: "anonymous",
        },
        {
          rel: "preload",
          href: "/fonts/Starling-Arrow.woff2",
          as: "font",
          crossOrigin: "anonymous",
        },
      ]}
    />
  );
};

export default props => (
  <StaticQuery
    query={graphql`
      {
        prismicHomepage {
          data {
            seo_keywords
            seo_text
            seo_image {
              url
            }
          }
        }
      }
    `}
    render={data => <DefaultSEO data={data} {...props} />}
  />
);
